// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#user-menu {
    position: absolute;
    top: 55px;
    right: 0px;
    text-align: left;
    border-radius: 7px;
    background-color: white;
    border-bottom: thin solid var(--header-menu-border-color);
    border-left: thin solid var(--header-menu-border-color);
    border-right: thin solid var(--header-menu-border-color);
    box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);
    padding: 10px 0 10px 0;
    z-index: 1000;
    white-space: nowrap;
}
#user-menu img {
    display: inline-block;
    width: 18px;
    height: 18px;
    margin-right: 6px;
    margin-bottom: -4px;
}
#user-menu .menu-section {
    padding: 5px 0;
    border-bottom: thin solid var(--header-menu-spacer-color);
}
#user-menu .menu-section.bottom {
    border-bottom: none;
}
#user-menu .menu-item a {
    display: block;
    padding: 5px 10px 5px 10px;
}
`, "",{"version":3,"sources":["webpack://./client/components/header/navigation/UserMenu.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,yDAAyD;IACzD,uDAAuD;IACvD,wDAAwD;IACxD,6CAA6C;IAC7C,sBAAsB;IACtB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,yDAAyD;AAC7D;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B","sourcesContent":["#user-menu {\n    position: absolute;\n    top: 55px;\n    right: 0px;\n    text-align: left;\n    border-radius: 7px;\n    background-color: white;\n    border-bottom: thin solid var(--header-menu-border-color);\n    border-left: thin solid var(--header-menu-border-color);\n    border-right: thin solid var(--header-menu-border-color);\n    box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);\n    padding: 10px 0 10px 0;\n    z-index: 1000;\n    white-space: nowrap;\n}\n#user-menu img {\n    display: inline-block;\n    width: 18px;\n    height: 18px;\n    margin-right: 6px;\n    margin-bottom: -4px;\n}\n#user-menu .menu-section {\n    padding: 5px 0;\n    border-bottom: thin solid var(--header-menu-spacer-color);\n}\n#user-menu .menu-section.bottom {\n    border-bottom: none;\n}\n#user-menu .menu-item a {\n    display: block;\n    padding: 5px 10px 5px 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
